import { useControls } from 'leva';
import { useDebugStore } from '@/store/useDebugStore';
import { useSettingsStore } from '@/store/useSettingsStore';

/**
 * Mounts the leva debug panel. Renders nothing itself — leva handles
 * its own DOM portal. Each control writes through to the corresponding
 * zustand store via `onChange` so 3D components react via subscription.
 */
export function DebugPanel() {
  const setPhysicsDebug = useDebugStore((s) => s.setPhysicsDebug);
  const setPostprocessing = useDebugStore((s) => s.setPostprocessing);
  const setShowPerf = useDebugStore((s) => s.setShowPerf);
  const setShowHud = useDebugStore((s) => s.setShowHud);
  const setShadows = useSettingsStore((s) => s.setShadows);
  const setDpr = useSettingsStore((s) => s.setDpr);
  const setAudioVolume = useSettingsStore((s) => s.setAudioVolume);

  useControls('Debug', {
    physicsDebug: { value: false, label: 'Physics debug', onChange: setPhysicsDebug },
    postprocessing: { value: false, label: 'Postprocessing', onChange: setPostprocessing },
    showPerf: { value: false, label: 'r3f-perf overlay', onChange: setShowPerf },
    showHud: { value: true, label: 'HUD', onChange: setShowHud },
  });

  useControls('Settings', {
    shadows: { value: true, label: 'Shadows', onChange: setShadows },
    dpr: { value: 1.5, min: 0.5, max: 3, step: 0.1, label: 'DPR', onChange: setDpr },
    audioVolume: { value: 1, min: 0, max: 1, step: 0.05, label: 'Volume', onChange: setAudioVolume },
  });

  return null;
}
